import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Checkbox } from "@common/checkbox";
import { useRoles } from "@scenes/safeguard";
import { Button } from "@common/button";
import { Props } from "./types";
import { Filters } from "./filters";
import {
  useExportData,
  useRetrieveSecondaryCriteriaTemplate,
  useRetrieveWbsConfiguration,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import {
  ExportsDataTypes,
  ExportsFormats,
  project,
  wbsFilter,
  Sort as S,
} from "@planzone/dto";
import { Sort } from "./sort";
import styles from "./styles.scss";

function WbsReport(props: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "projectElement",
  );
  const { configuration } = useRetrieveWbsConfiguration(planzone);
  const roles = useRoles({});
  const [sort, setSort] = React.useState<S | null>(null);
  const [filter, setFilter] = React.useState(wbsFilter);
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const { isRequestPending, exportData } = useExportData();

  return (
    <div
      className={classNames(styles.wbsReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("exportReportsPage.wbsZonesReport.title")}
          </h2>
          <p className={styles.description}>
            {t("exportReportsPage.wbsZonesReport.subTitle")}
          </p>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.PLANZONE_WBS_REPORT,
                  data: {
                    sort: sort ? [sort] : undefined,
                    filter,
                    planzone: props.planzone,
                    projects: [],
                    template: template,
                    configuration: configuration,
                    roles: roles,
                  },
                },
                format: ExportsFormats.EXCEL,
              })
            }
          >
            {t("exportReportsPage.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <Sort sort={sort} select={setSort} />
          <Filters project={project} filter={filter} setFilter={setFilter} />
        </div>
      )}
    </div>
  );
}

export { WbsReport };
